import { LiturgyItem } from "./types";

export const getTurnUsThen = (): LiturgyItem[] => {
    return [
        {
            type: "chant",
            boldMode: "none",
            tone: "2.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Turn",
                                        notes: ["1"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "then",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "God",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Sav",
                                        notes: ["2"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "iour.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
        {
            type: "chant",
            boldMode: "all",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: ["1"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "let",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thine",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "an",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ger",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "cease",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "from",
                                        notes: ["2"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "us.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
    ];
};
